// pages/HomePage.tsx
import React from 'react';
import Hero from '../components/Hero';
import Features from '../components/Features';
import Services from '../components/Services';

const HomePage: React.FC = () => {
  return (
    <>
      <Hero />
      <Features />
      <Services />
    </>
  );
};

export default HomePage;